import {
  SAVE_DASHBOARD_CHECKBOXES_VALUES,
  SAVE_HISTORY_CHECKBOXES_VALUES
} from "../constants/dashboard";

export const saveDashboardCheckboxesValues = data => ({
  type: SAVE_DASHBOARD_CHECKBOXES_VALUES,
  payload: data
});

export const saveHistoryCheckboxesValues = data => ({
  type: SAVE_HISTORY_CHECKBOXES_VALUES,
  payload: data
});
